import React, {Component} from 'react';
import CdmLayout from "../../../templates/cdm";
import {NavLink} from "react-router-dom";
import ProgressBar from "../../elements/widgets/progress-bar";
import _ from "lodash";
import current_tasks from "../../json/current_tasks";
import directoryList from "../../json/places";
import DirectoryServiceItem from "../../elements/directory/directory-service-item";
import ServiceDirectoryForm from "../../elements/directory/service-form";

class CdmServicesDirectory extends Component {
	render() {
		let activity = _.find(current_tasks.data, {id: _.toInteger(this.props.match.params.id)});
		let step = _.find(activity.tasks, {id: _.toInteger(this.props.match.params.step)});
		return <div className="columns is-multiline">
			<div className="column is-10 is-offset-1">
				<div className="column is-12">
					<div className="level">
						<NavLink to={`/cdm/tarea/${activity.id}`} className="button is-cdm-blue is-small"><i className="fa fa-arrow-left" style={{marginRight: '10px'}} /> Volver a la tarea</NavLink>
					</div>
				</div>
				<div className="column is-12">
					<div className="level cdm-header--dates">
						<div className="level-left">
							<div className="level-item">
								<p className="due-date">
									<span>Fecha límite</span>
									{step.date_finish}
								</p>
							</div>
						</div>
						<div className="level-right">
							<div className="level-item progress-detail">
								<ProgressBar total={100} detect={100} />
							</div>
						</div>
					</div>
					<div className={`cdm-header ${activity.category.style}`}>
						<div className="cdm-header--details">
							<p className="category">{activity.category.name}</p>
							<p>{step.duration} días</p>
						</div>
						<div className="cdm-header--title">
							<h1>{`${step.step}. ${step.title}`}</h1>
							<div className="modified">
								<p>
									<span>Última modificación</span>
									2018-08-16
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className="column is-12">
					<ServiceDirectoryForm addEntry={this.addEntry} places={this.state.directory.list} nextId={this.state.directory.detail} />
				</div>
				<hr/>
				<div className="column is-12">
					<div className="cdm-directory">
						{_.map(this.state.directory.list, (dir) => {
							return _.isEmpty(dir.services) ? '' :
							_.map(dir.services, (service, s) => {
								return <DirectoryServiceItem {...service} place={dir} key={s} />
							})
						})}
					</div>
				</div>
			</div>
		</div>
	}

	constructor() {
		super();
		this.addEntry = this.addEntry.bind(this);
		this.state = {
			directory: {
				list: [...directoryList.data],
				detail: 3
			}
		}
	}

	addEntry(place, service) {
		let id = this.state.directory.detail+1;
		return this.setState({
			directory: {
				...this.state.directory,
				detail: id,
				list: _.map(this.state.directory.list, (dir) => {
						if(dir.id === _.toInteger(place)) {
							let newDir = _.clone(dir.services);
							newDir.push(service);
							return Object.assign({}, dir, {services: newDir});
						}else{
							return dir;
						}
					})

			}
		})
	}
}


export default CdmLayout(CdmServicesDirectory, {
	title: 'Directorio de instituciones',
	subnav: {
		icon: 'fa-building',
		name: 'Directorio',
		actions: [
		]
	},
	stateNav: true,
	progress: true
});



// WEBPACK FOOTER //
// ./src/cdm-frontend/pages/substantial/directory-services.jsx